import React, { useContext, useState } from 'react'
import Renderer from '@sketch-hq/sketch-web-renderer'

interface WebRendererContext {
  renderer: Renderer | null
  setRenderer: (renderer: Renderer) => void
}

export const webRendererContext = React.createContext<WebRendererContext>(
  {} as WebRendererContext
)

type WebRendererContextProviderProps = {
  children: React.ReactNode
}
export function WebRendererContextProvider({
  children,
}: WebRendererContextProviderProps) {
  const [renderer, setRenderer] = useState<Renderer | null>(null)

  const context: WebRendererContext = {
    renderer: renderer,
    setRenderer: setRenderer,
  }

  return (
    <webRendererContext.Provider value={context}>
      {children}
    </webRendererContext.Provider>
  )
}

/**
 * Get the web renderer context to access or set
 * the web canvas renderer instance.
 */
export function useWebRendererContext() {
  return useContext(webRendererContext)
}
